// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".DocumentItem-tools-icon-DpGbp {\n  width: 47px;\n  height: 42px;\n}\n", "",{"version":3,"sources":["webpack://./src/globals/document/DocumentItem.less"],"names":[],"mappings":"AACA;EACI,WAAA;EACA,YAAA;AAAJ","sourcesContent":["@environment_type_id: 1;\n.tools-icon{\n    width: 47px;\n    height: 42px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tools-icon": "DocumentItem-tools-icon-DpGbp"
};
export default ___CSS_LOADER_EXPORT___;
